import { render, staticRenderFns } from "./FormFeedbackNewsBlock.vue?vue&type=template&id=959bc346&scoped=true&"
import script from "./FormFeedbackNewsBlock.vue?vue&type=script&lang=js&"
export * from "./FormFeedbackNewsBlock.vue?vue&type=script&lang=js&"
import style0 from "./FormFeedbackNewsBlock.vue?vue&type=style&index=0&id=959bc346&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959bc346",
  null
  
)

export default component.exports